import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthRealmService } from './auth-realm.service';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class ChangeOrganisationService {
  private authService = inject(AuthService);

  private readonly realm = AuthRealmService.getRealm();

  readonly wnLocalStorageKey = 'wn-should-change-organisation';
  readonly shouldChangeOrg = localStorage.getItem(this.wnLocalStorageKey);

  changeOrganisation(): void {
    if (this.realm === environment.APP_WACKER_NEUSON_REALM) {
      this.wnChangeOrganisation();
      return;
    }
    // For now, this feature is exclusive to Wackerneuson
    throw new Error('External change of organisation not available');
  }

  clearWnShouldChangeOrgFromLocalStorage(): void {
    localStorage.removeItem(this.wnLocalStorageKey);
  }

  private wnChangeOrganisation(): void {
    localStorage.setItem(this.wnLocalStorageKey, 'true');
    this.authService.logout();
  }
}
